var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphStatsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.40039 2.3999V12.3555C2.40039 12.6855 2.5315 13.002 2.76488 13.2354C2.99826 13.4688 3.31479 13.5999 3.64484 13.5999H13.6004M12.3559 6.13324L9.24484 9.24435L6.75595 6.75546L4.88928 8.62212",
    stroke: "#33363F",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphStatsIcon);
export default __webpack_public_path__ + "static/media/graphStatsIcon.99e0242e47f7fb480730425e73ace37d.svg";
export { ForwardRef as ReactComponent };